import { useTheme } from 'ui';
import { TextField } from 'vendor/material';

export default function DefaultValueLoading() {
  const theme = useTheme();

  return (
    <TextField
      id={'default-value-loading'}
      placeholder={'Loading...'}
      variant="outlined"
      disabled={true}
      size="small"
      fullWidth
      InputProps={{
        style: {
          fontSize: theme.typography.pxToRem(14),
          fontWeight: 600,
        },
      }}
    />
  );
}
